import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Polygon as VisPolygon } from '@vis.gl/react-google-maps';
import { useReportBounds } from "../lib/BoundsRegistry";
export const Polygon = ({ path, editable, draggable, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, onPathChanged, onClick }) => {
    useReportBounds(useMemo(() => path, [JSON.stringify(path)]));
    return (_jsx(VisPolygon, { paths: [path], editable: editable ?? true, draggable: draggable ?? true, strokeColor: strokeColor ?? '#000000', strokeOpacity: strokeOpacity ?? 0.8, strokeWeight: strokeWeight ?? 4, fillColor: fillColor ?? '#000000', fillOpacity: fillOpacity ?? 0.3, onClick: () => onClick?.(), onPathsChanged: paths => {
            if (!onPathChanged || !paths.length) {
                return;
            }
            const newPath = paths[0].map(p => ({ lat: p.lat(), lng: p.lng() }));
            const bounds = new google.maps.LatLngBounds();
            newPath.forEach(p => bounds.extend(p));
            const center = bounds.getCenter();
            onPathChanged({ lat: center.lat(), lng: center.lng() }, newPath);
        } }));
};
